import { REPEATABLE_DATAS } from 'consts';
export const services = {
    auth: 'auth/v1/auth',
    banner_ms: 'abb-cb-banner-ms/v1',
    mail: 'auth/v1/mail',
    user: 'user/v1/users',
    users: 'user/v1/users',
    account: 'account/v1/accounts',
    account_opening: 'account-opening/v1',
    payment: 'payment/v1/payments',
    salary_payment: 'salary-payment/v1/payments',
    bulk_payment: 'bulk-mix-payment/v1/payments',
    own_accounts_payment: 'own-payment/v1/payments',
    domestic_payment: 'domestic-payment/v1/payments',
    vat_payment: 'domestic-payment/v1/payments/vat',
    tax_payment: 'domestic-payment/v1/payments/tax',
    ibmg_payment: 'domestic-payment/v1/payments/ibmg',
    ibtf_payment: 'domestic-payment/v1/payments/ibtf',
    internal_payment: 'internal-payment/v1/payments',
    international_payment: 'international-payment/v1/payments',
    dictionary: 'dictionary/v1/branch',
    dictionary_api: REPEATABLE_DATAS.DICTIONARY,
    dictionary_cutoff: 'dictionary/v1/cutoff',
    dictionary_swift: REPEATABLE_DATAS.DICTIONARY,
    dictionary_check_iban: REPEATABLE_DATAS.DICTIONARY,
    dictionary_check_account: 'dictionary/v1/correspondent-account',
    commission: 'commission/v1/commission',
    files: 'file-storage/v1/files',
    find_templates: 'payment/v1/templates',
    salary_payment_templates: 'salary-payment/v1/templates',
    own_accounts_payment_templates: 'own-payment/v1/templates',
    internal_payment_templates: 'internal-payment/v1/templates',
    domestic_payment_templates: 'domestic-payment/v1/templates',
    international_payment_templates: 'international-payment/v1/templates',
    swift_tracking: 'dictionary/v1/swift-track',
    onboarding: 'onboarding-ms/v1',
    notification_ms: 'notification-ms/v1',
    e_customs: 'ecustom-wallet/v1',
    exchange: 'exchange/v1',
    user_profile: 'profile/v1/users/permissions',
    gpp: 'gpp/v1',
    special_card: 'special-card/v1',
    list: 'profile/v1/operations',
    referral: 'abb-cb-referral-ms/v1',
    survey: 'abb-cb-csi-ms/v1/csi',
    subjects: 'abb-cb-mailbox-ms/v1/subjects',
    mailbox_mail: 'abb-cb-mailbox-ms/v1/mail',
    dashboard_ms: 'abb-cb-dashboard-ms/v1',
    salary_cards: 'salary-card-order/v1',
    loan_orders: 'loan/v1/orders',
    loyalty: 'api/loyalty-processing-ms/v1'
};
